module.exports = __webpack_public_path__ + "static/media/slider1.74f5754c.jpg";